import { render } from "./WebsiteGuide.vue?vue&type=template&id=16559d4b&scoped=true"
import script from "./WebsiteGuide.vue?vue&type=script&lang=js"
export * from "./WebsiteGuide.vue?vue&type=script&lang=js"

import "./WebsiteGuide.vue?vue&type=style&index=0&id=16559d4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16559d4b"]])

export default __exports__